<template>
	<div v-loading="element_loading" element-loading-text="拼命加载中......" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<div class="title">
			<div id="notice">
				<h5>通知使用说明:<br>
					<span>1、单号构成规则:201201+4位顺序号。系统生成,添加无效...</span><br>
					<span>2、提交后为锁定状态,如需修改请先作废。</span><br>
					<span>3、查询关键字:单号、类型、进度、内容。</span><br>
				</h5>
			</div>
		</div>

		<!-- 动态按钮生成 -->
		<div class="content_edit">
			<pre-button @button-event="select_method" :pre_control="control" />
			<div class="content_btn">
				<div class="content_btn_item">
					<slot name="pre_base_button"></slot>
					<button @click="look_note">备注说明</button>
					<button class="pre_btn_ok" @click="fun_show_file">附件管理</button>
					<button class="pre_btn_ok" @click="closeshow()">{{title_sel}}</button>
					<button class="pre_btn_ok" @click="fun_show_edit()">{{title_edit}}</button>
					<span class="red" style="font-weight: bold;">
						{{sheet_flag}}
					</span>
				</div>

				<!-- <div class="content_edit_item">
          <h3 class="red">
            {{sheet_flag}}
          </h3>
        </div> -->

			</div>
		</div>
		<!-- 动态查询区生成 start  -->
		<el-collapse-transition>
			<div v-show="show_main_sel" class="content_edit edit_color ">
				<div class="content_edit_item" v-for="(item,index) in parm_sel" :key="index">
					<component :is="NextTickName(item.type)" :inData="checkJson(item)" @com-event="refresh_view_sel">
					</component>
				</div>
			</div>
		</el-collapse-transition>
		<!-- 动态查询区生成 end  -->

		<!-- 动态编辑区域 start -->
		<el-collapse-transition>
			<div v-show="show_main_edit" class="content_edit">
				<!-- 这里放主单据编辑内容-->
				<div class="content_edit">

					<div class="content_edit_item tab-row" v-for="(r,d) in max_row" :key="d">
						<div class="content_edit_item" v-if="item.x == r.row" v-for="(item,index) in parm" :key="index">
							<component :is="NextTickName(item.type)" :inData="checkJson(item)"
								@com-event="refresh_view_edit">
							</component>
						</div>
					</div>

					<div class="content_edit_item" v-show="file_show">
						<label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
					</div>


				</div>

			</div>
		</el-collapse-transition>
		<!-- 动态编辑区域 end -->

		<!-- 主界面内容显示 start -->
		<pre-table ref="file_table" @tab-event="refresh_data" :api_url="load_url" :pre_post="load_json"
			:pre_post_upd="upd_json">
			<!-- 设定标题  -->
			<template slot="tab_title">
				<tr :class="[isTwo=='1'?TwoNone:'']">
					<td v-for="(t,index) in parm_th" :class="[t.class!=''?t.class:'tab_w']" :key="index">{{t.name}}</td>
				</tr>
			</template>
			<template slot="tab_tr" slot-scope="user">
				<tr :id="'m_'+user.item.row_num" :class="[isTwo=='1'?TwoNone:'']" @click="sel_row(user.item,'all')"
					@dblclick="fun_show_edit(user.item)">
					<!-- <a href="#"> -->
					<!-- <td v-for="(d,index) in user.item" :key="index"
            v-on:mousemove="show_detaildata($event, d.val, '1')"
            v-on:mouseout="noshow_detaildata">
            <a href="#">{{d.val}}</a>
          </td> -->
					<td>{{user.item.row_num}}</td>
					<td>{{user.item.sheet_no}}</td>
					<td>
						{{user.item.flag}}
					</td>
					<td>{{user.item.c_type}}</td>
					<td class="long2" v-on:mousemove="show_detaildata($event, user.item.one_name, '1')"
						v-on:mouseout="noshow_detaildata">{{user.item.one_name}}</td>
					<td class="long1_3">{{user.item.one_no}}</td>
					<td class="long1_3">{{user.item.one_phone}}</td>
					<td class="long2" v-on:mousemove="show_detaildata($event, user.item.two_name, '1')"
						v-on:mouseout="noshow_detaildata">{{user.item.two_name}}</td>
					<td class="long1_3">{{user.item.two_no}}</td>
					<td class="long1_3">{{user.item.two_phone}}</td>
					<td>{{user.item.amount}}</td>
					<td v-on:mousemove="show_detaildata($event, user.item.c_step, '1')"
						v-on:mouseout="noshow_detaildata">
						{{user.item.c_step}}
					</td>
					<td>{{user.item.f_flag}}</td>
					<td class="long2">
						<ul>
							<li v-for="(t,id) in user.item.detail" :index="id">
								<button @click="fun_show_detail(t)">{{t.f_name}}</button>
							</li>
						</ul>
					</td>
					<td class="long2" v-on:mousemove="show_detaildata($event, user.item.c_data, '1')"
						v-on:mouseout="noshow_detaildata">
						{{user.item.c_data}}
					</td>
					<td v-on:mousemove="show_detaildata($event, user.item.note, '1')" v-on:mouseout="noshow_detaildata">
						{{user.item.note}}
					</td>
					<td class="long2">
						{{user.item.law_firm}}
					</td>
					<td>
						{{user.item.law_leader}}
					</td>
					<td>
						{{user.item.law_date}}
					</td>
					<td>
						{{user.item.law_user}}
					</td>
					<td>
						{{user.item.law_amount}}
					</td>
					<td v-on:mousemove="show_detaildata($event, user.item.ss_txt, '1')"
						v-on:mouseout="noshow_detaildata">
						{{user.item.ss_txt}}
					</td>
					<td v-on:mousemove="show_detaildata($event, user.item.pj_txt, '1')"
						v-on:mouseout="noshow_detaildata">
						{{user.item.pj_txt}}
					</td>
					<td>
						{{user.item.law_fee}}
					</td>
					<td>
						{{user.item.pay_his}}
					</td>
					<td>
						{{user.item.pay_date}}
					</td>
					<td>
						{{user.item.pay_fp}}
					</td>
					<td>
						{{user.item.fp_amount}}
					</td>
					<td>
						{{user.item.fp_date}}
					</td>
					<td>
						{{user.item.pay_note}}
					</td>
					<td>
						{{user.item.ss_other}}
					</td>
					<td>{{user.item.u_name}}</td>
					<td>{{user.item.sys_date}}</td>
					<!-- </a> -->
				</tr>
			</template>
			<!-- 构建新增模板 -->
			<template slot="tab_addorupdate">

			</template>
		</pre-table>
		<!-- 主界面内容显示 end -->


		<!-- 通用导入excel -->
		<!--    <per-excelup ref="excelup" @excelup-event="refresh_data" :pre_th="d_parm" :api_url="d_sel_action"
      :api_action="d_upd_action" /> -->



		<!-- 通用导出excel -->
		<per-exceldown v-show="show_excel" @exceldown-event="build_exceldata" :title="'下载数据'"
			v-bind:pre_postjson="postjson1" :clicktype="'down1'">
			<template slot="tab_excelup_title">
				<tr>
					<th>ID</th>
					<th v-for="(t,index) in parm_th_exl" :key="index">{{t.name}}</th>
				</tr>
			</template>
			<template slot="tab_excelup_tr" slot-scope="user">
				<tr @click="sel_row(user.item)">
					<td v-for="(d,index) in user.item" :key="index">{{d.val}}</td>
				</tr>
			</template>
		</per-exceldown>

		<step-tan ref="mystep"></step-tan>
		<longtxt-tan ref="mylongtxt"></longtxt-tan>
		<caseother-tan ref="myother"></caseother-tan>

		<!-- 隐藏聚焦点 -->
		<div><input id="pre_displaynone" style="display:none;" /></div>

		<prefile :pre_show_tan="show_file" :pre_data="show_filedata" />


		<!-- 明细数据提示 -->
		<div id="pre_detail_data" style="display:none;">
			<p v-for="(item, index) in detail_data" :key="index">
				{{ item.name }}={{ item.amount }}
			</p>
		</div>
		<div id="pre_msg_data" style="display:none;"></div>

		<!-- 文件预览部分 -->
		<!-- 弹出向导层 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" id="hetong_file" v-on:change="getFilePath" />

		<a id="editdownlink"></a>
		<a id="loodlink" target="_blank"></a>

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Select_PageLength,
		Method_Common,
		Method_CommonLong,
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';

	import {
		downloadfile
	} from '@/utils/download2.js';
	import {
		base64ToBin
	} from '@/utils/strToBase64.js'
	
	import {
		JsonCheck
	} from '@/utils/method.js';

	export default {
		name: "pre_base_table_new",
		components: {
			"pre-button": () => import("../per_old/pre_btn_no_new.vue"),
			"pre-table": () => import("../per_old/pre_table_nokey_20230413.vue"),
			'per-exceldown': () => import("../per_old/pre_excel_down.vue"),
			'per-excelup': () => import("../per_old/pre_excel_up_new.vue"),
			'pre-sel-one': () => import("../per_old/pre_select_one.vue"),
			'step-tan': () => import("./tan_step.vue"),
			'longtxt-tan': () => import("./tan_longtxt.vue"),
			'caseother-tan': () => import("./tan_caseother.vue")

		},
		data() {
			return {
				element_loading: false,
				control: '',
				load_url: '',
				load_json: '',
				upd_json: '',
				bak_data: '', //防止重复操作记录
				nowpage: '1',
				page_length: 20,
				title: '未设置标题',
				sel_action: '',
				upd_action: '',
				row_id: '',
				sel_item: [], //备份点击项目
				sys_date: '',
				// 审核标记
				sheet_flag: '',
				sheet_no: '',


				action_type: "long",
				parm_sel: [], //查询结构
				parm: [], //参数结构
				parm_th: [], //标题
				kw1: '',
				kw2: '',
				kw3: '',
				kw4: '',
				kw5: '',
				kw6: '',
				kw7: '',
				kw8: '',

				// excel
				show_excel: false,
				postjson1: {},
				// radio
				radio: '1',
				d_radio: '1',
				// 编辑区域隐藏控制
				show_main_edit: true,
				show_main_sel: false,
				title_edit: '关闭编辑',
				title_sel: '开始查询',

				// 备注
				detail_data: '',
				//文件
				file_show: false,
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',
				// swich 开关
				show_in: true,
				show_out: false,
				// checkbox 组件
				isIndeterminate: true,

				// 定义默认样式
				isTwo: '0',
				isOne: '0',
				TwoNone: 'last-two-none',
				OneNone: 'last-one-none',

				show_file: '0',
				show_filedata: '',

				one_name: '',

				max_row: [],
				parm_th_exl: []

			};
		},
		created: function() {
			this.load_data();
		},
		watch: {
			sheet_flag(val) {
				console.log('flag=' + val);
				if (val == '已提交') {
					this.show_detail_edit = false;
				} else {
					this.show_detail_edit = true;
				}
			},
			show_in(val) {
				// console.log('==' + val);
				if (val) {
					this.show_out = false;
				} else {
					this.show_out = true;
				}
			},
			upd_action(val) {
				console.log(val);
				if (typeof(val) == 'undefined' || val == '') {
					this.show_main_edit = false;
				}
			}

		},
		methods: {
			NextTickName: function(key) {
				// console.log('key=' + key);
				return 'pre' + key;
			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_sel: function(d) {
				// console.log('查询回传=', d);
				for (let i = 0; i < this.parm_sel.length; i++) {
					if (this.parm_sel[i].key == d.key) {
						this.parm_sel[i].val = d.val;
						break;
					}
				}
			},
			refresh_view_edit: function(d, type) {
				console.log(d);
				if (type == 'click') {
					this.select_item(d);
					return;
				}
				for (let i = 0; i < this.parm.length; i++) {
					if (this.parm[i].key == d.key) {
						if (this.parm[i].type == 'select' || this.parm[i].type == 'radio') {
							this.parm[i].val = d.val;
							this.parm[i].sel_name = d.sel_name;
							break;
						} else {
							this.parm[i].val = d.val;
							break;
						}
					}
				}
			},
			select_item: function(d) {
				console.log('点击', d);
				if (this.sheet_no == '') {
					return;
				}
				let post_tan = '';
				switch (d.key) {
					case 'c_step':
						post_tan = JSON.stringify({
							"title": this.sheet_no + " 业务参数设置",
							"sheet_no": this.sheet_no,
							"sel_action": "exp_fw_case_stepinfo",
							"upd_action": "fw_casestepinfo",
							"parm": [{
									"name": "案件进度",
									"val": "",
									"key": "s_name",
									"type": "select",
									"class": "long1",
									"sel_action": "_base_case_step",
									"sel_name": "",
									"p": "1",
									"x": "1"
								},
								{
									"name": "更新日期",
									"val": "",
									"key": "s_date",
									"type": "date",
									"class": "long1",
									"p": "1",
									"x": "1"
								},
								{
									"name": "经办人",
									"val": "",
									"key": "u_name",
									"type": "text",
									"class": "long1",
									"p": "1",
									"x": "1"
								}, {
									"name": "备注",
									"val": "",
									"key": "note",
									"type": "text",
									"class": "long2",
									"p": "1",
									"x": "4"
								}
							],
							"parm_th": []
						})
						this.$refs.mystep.showpop(post_tan);
						break;
					case 'c_data':
						post_tan = JSON.stringify({
							"title": this.sheet_no + " 案例概述:",
							"sheet_no": this.sheet_no,
							"sheet_key": "c_data",
							"sel_action": "case_info_cdata",
							"upd_action": "case_info_cdata",
							"parm": [],
							"parm_th": []
						})
						this.$refs.mylongtxt.showpop(post_tan);
						break;
					case 'ss_txt':
						post_tan = JSON.stringify({
							"title": this.sheet_no + " 诉讼请求:",
							"sheet_no": this.sheet_no,
							"sheet_key": "ss_txt",
							"sel_action": "case_info_cdata",
							"upd_action": "case_info_cdata",
							"parm": [],
							"parm_th": []
						})
						this.$refs.mylongtxt.showpop(post_tan);
						break;
					case 'pj_txt':
						post_tan = JSON.stringify({
							"title": this.sheet_no + " 判决结果:",
							"sheet_no": this.sheet_no,
							"sheet_key": "pj_txt",
							"sel_action": "case_info_cdata",
							"upd_action": "case_info_cdata",
							"parm": [],
							"parm_th": []
						})
						this.$refs.mylongtxt.showpop(post_tan);
						break;
					case 'ss_other':
						post_tan = JSON.stringify({
							"title": this.sheet_no + " 其他费用:",
							"sheet_no": this.sheet_no,
							"sel_action": "exp_fw_case_info_otherpay",
							"upd_action": "_fw_case_info_otherpay",
							"parm": [{
									"name": "费用名称",
									"val": "",
									"key": "p_name",
									"type": "text",
									"class": "long1",
									"p": "1",
									"x": "1"
								},
								{
									"name": "支付金额",
									"val": "",
									"key": "p_fee",
									"type": "number",
									"class": "long1",
									"p": "1",
									"x": "1"
								},
								{
									"name": "支付日期",
									"val": "",
									"key": "p_date",
									"type": "date",
									"class": "long1",
									"p": "1",
									"x": "1"
								},
								{
									"name": "支付方式",
									"val": "",
									"key": "p_way",
									"type": "text",
									"class": "long1",
									"p": "1",
									"x": "1"
								},
								{
									"name": "经办人",
									"val": "",
									"key": "u_name",
									"type": "text",
									"class": "long1",
									"p": "1",
									"x": "2"
								}, {
									"name": "备注",
									"val": "",
									"key": "note",
									"type": "text",
									"class": "long2",
									"p": "1",
									"x": "2"
								}
							],
							"parm_th": []
						})
						this.$refs.myother.showpop(post_tan);
						break;



				}

			},
			GetRandom() {
				return (Math.random() + '').substring(0, 8);
			},
			new_blank: async function() {
				this.show_main_edit = true;
				this.show_main_sel = false;
				this.d_detail = [];
				await this.data_clear();
			},
			fun_show_edit: function() {

				this.show_main_edit = this.show_main_edit ? false : true;
				if (this.show_main_edit) {
					this.title_edit = '关闭编辑';
				} else {
					this.title_edit = '开始编辑';
				}

			},
			closeshow: function() {
				this.show_main_sel = this.show_main_sel ? false : true;
				if (this.show_main_sel) {
					this.title_sel = '关闭筛选';
				} else {
					this.title_sel = '开始筛选';
				}

			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			load_data: async function() {
				// 初始化最大行数
				this.max_row = [];
				for (let i = 1; i < 10; i++) {
					let o = {};
					o.row = i;
					this.max_row.push(o);
				}

				let list_type = [];
				list_type = await this.loadClass('data_base_case_type');
				let list_step = [];
				list_step = await this.loadClass('data_base_case_step');
				let list_flag = [];
				list_flag = await this.loadClass('data_flag');

				this.title = '案例';
				this.control = 'casedata';


				this.sel_action = 'exp_fw_case';
				this.upd_action = 'ca0_case';

				this.file_action = 'ca0_case';
				this.p1 = 'fawu';
				this.p2 = 'case';
				this.p3 = '';
				this.parm_sel = [{
						"name": "单号",
						"val": "",
						"key": "sheet_no",
						"type": "text",
						"class": "long1",
						"sel": "1"
					},
					{
						"name": "案件类型",
						"val": "",
						"key": "c_type",
						"type": "select",
						"class": "long1",
						"list": list_type.data,
						"sel_val": {},
						"sel_name": "",
						"sel": "2"
					},
					{
						"name": "案件进度",
						"val": "",
						"key": "c_step",
						"type": "select",
						"class": "long1",
						"list": list_step.data,
						"sel_val": {},
						"sel_name": "",
						"sel": "3"
					},
					{
						"name": "状态",
						"val": "",
						"key": "flag",
						"type": "select",
						"class": "long1",
						"list": list_flag.data,
						"sel_val": {},
						"sel_name": "",
						"sel": "4"
					}
				];

				this.parm = [{
						"name": "单号",
						"val": "",
						"key": "sheet_no",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "1",
						"r": "1"
					},
					{
						"name": "案件类型",
						"val": "",
						"key": "c_type",
						"type": "select",
						"class": "long1",
						"weight": "1",
						"list": list_type.data,
						"sel_val": {},
						"sel_name": "",
						"p": "1",
						"x": "1"
					},
					{
						"name": "原告姓名",
						"val": "",
						"key": "one_name",
						"type": "text",
						"class": "long1",
						"weight": "1",
						"p": "1",
						"x": "2"
					},
					{
						"name": "原告证件",
						"val": "",
						"key": "one_no",
						"type": "text",
						"class": "long1",
						"weight": "1",
						"p": "1",
						"x": "2"
					},
					{
						"name": "原告电话",
						"val": "",
						"key": "one_phone",
						"type": "text",
						"class": "long1",
						"weight": "1",
						"p": "1",
						"x": "2"
					},
					{
						"name": "被告姓名",
						"val": "",
						"key": "two_name",
						"type": "text",
						"class": "long1",
						"weight": "1",
						"p": "1",
						"x": "2"
					},
					{
						"name": "被告证件",
						"val": "",
						"key": "two_no",
						"type": "text",
						"class": "long1",
						"weight": "1",
						"p": "1",
						"x": "2"
					},
					{
						"name": "被告电话",
						"val": "",
						"key": "two_phone",
						"type": "text",
						"class": "long1",
						"weight": "1",
						"p": "1",
						"x": "2"
					},
					{
						"name": "涉案金额",
						"val": "",
						"key": "amount",
						"type": "number",
						"class": "long1",
						"weight": "1",
						"p": "1",
						"x": "1"
					},
					{
						"name": "案件进度",
						"val": "",
						"key": "c_step",
						"type": "text",
						"class": "long1",
						"p": "1",
						"r": "1",
						"x": "1"
					},
					{
						"name": "案例概述",
						"val": "",
						"key": "c_data",
						"type": "textarea",
						"class": "long5",
						"p": "1",
						"r": "1",
						"x": "3"
					},
					{
						"name": "备注",
						"val": "",
						"key": "note",
						"type": "text",
						"class": "long3",
						"weight": "1",
						"p": "1",
						"x": "4"
					},
					{
						"name": "律师事务所",
						"val": "",
						"key": "law_firm",
						"type": "text",
						"class": "long1",
						"p": "1",
						"r": "0",
						"x": "5"
					},
					{
						"name": "负责律师",
						"val": "",
						"key": "law_leader",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "5"
					},
					{
						"name": "代理日期",
						"val": "",
						"key": "law_date",
						"type": "date",
						"class": "long1",
						"p": "1",
						"x": "5"
					},
					{
						"name": "代理律师",
						"val": "",
						"key": "law_user",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "5"
					},
					{
						"name": "诉讼标的金额",
						"val": "",
						"key": "law_amount",
						"type": "number",
						"class": "long1",
						"p": "1",
						"x": "5"
					},
					{
						"name": "诉讼请求",
						"val": "",
						"key": "ss_txt",
						"type": "textarea",
						"class": "long5",
						"p": "0",
						"r": "1",
						"x": "6"
					},
					{
						"name": "判决结果",
						"val": "",
						"key": "pj_txt",
						"type": "textarea",
						"class": "long5",
						"p": "0",
						"r": "1",
						"x": "6"
					},
					{
						"name": "诉讼费",
						"val": "",
						"key": "law_fee",
						"type": "number",
						"class": "long1",
						"p": "1",
						"x": "7"
					},
					{
						"name": "转款记录",
						"val": "",
						"key": "pay_his",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "7"
					},
					{
						"name": "转款日期",
						"val": "",
						"key": "pay_date",
						"type": "date",
						"class": "long1",
						"p": "1",
						"x": "7"
					},
					{
						"name": "其他费用",
						"val": "",
						"key": "ss_other",
						"type": "text",
						"class": "long1",
						"p": "0",
						"r": "1",
						"x": "7"
					},
					{
						"name": "开票信息",
						"val": "",
						"key": "pay_fp",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "8"
					},
					{
						"name": "开票金额",
						"val": "",
						"key": "fp_amount",
						"type": "number",
						"class": "long1",
						"p": "1",
						"x": "8"
					},
					{
						"name": "开票日期",
						"val": "",
						"key": "fp_date",
						"type": "date",
						"class": "long1",
						"p": "1",
						"x": "8"
					},
					{
						"name": "付款方式",
						"val": "",
						"key": "pay_note",
						"type": "text",
						"class": "long1",
						"p": "1",
						"x": "8"
					}

				];

				this.parm_th = [{
						"name": "序号"
					},
					{
						"name": "单号"
					},
					{
						"name": "状态"
					},
					{
						"name": "案件类型"
					},
					{
						"name": "原告姓名",
						"class": "long2"
					},
					{
						"name": "原告证件",
						"class": "long1_3"
					},
					{
						"name": "原告电话",
						"class": "long1_3"
					},
					{
						"name": "被告姓名",
						"class": "long2"
					},
					{
						"name": "被告证件",
						"class": "long1_3"
					},
					{
						"name": "被告电话",
						"class": "long1_3"
					},
					{
						"name": "涉案金额"
					},
					{
						"name": "案例进度"
					},
					{
						"name": "附件数量"
					},
					{
						"name": "附件查看",
						"class": "long2"
					},
					{
						"name": "案例概述",
						"class": "long2"
					},
					{
						"name": "备注"
					},
					{
						"name": "律师事务所",
						"class": "long2"
					},
					{
						"name": "负责律师"
					},
					{
						"name": "代理日期"
					},
					{
						"name": "代理律师"
					},
					{
						"name": "诉讼标的金额"
					},

					{
						"name": "诉讼请求"
					},
					{
						"name": "判决结果"
					},
					{
						"name": "诉讼费"
					},
					{
						"name": "转款记录"
					},
					{
						"name": "转款日期"
					},
					{
						"name": "开票信息"
					},
					{
						"name": "开票金额"
					},
					{
						"name": "开票日期"
					},
					{
						"name": "付款方式"
					},
					{
						"name": "其他费用"
					},
					{
						"name": "修改人"
					},
					// {
					//   "name": "浏览地址"
					// },
					// {
					//   "name": "存储地址"
					// },
					{
						"name": "修改时间"
					}
				]

				this.parm_th_exl = [{
						"name": "序号"
					},
					{
						"name": "单号"
					},

					{
						"name": "案件类型"
					},
					{
						"name": "原告姓名",
						"class": "long2"
					},
					{
						"name": "原告证件",
						"class": "long1_3"
					},
					{
						"name": "原告电话",
						"class": "long1_3"
					},
					{
						"name": "被告姓名",
						"class": "long2"
					},
					{
						"name": "被告证件",
						"class": "long1_3"
					},
					{
						"name": "被告电话",
						"class": "long1_3"
					},
					{
						"name": "涉案金额"
					},
					{
						"name": "案例进度"
					},

					{
						"name": "案例概述",
						"class": "long2"
					},
					{
						"name": "备注"
					},
					{
						"name": "律师事务所",
						"class": "long2"
					},
					{
						"name": "负责律师"
					},
					{
						"name": "代理日期"
					},
					{
						"name": "代理律师"
					},
					{
						"name": "诉讼标的金额"
					},
					{
						"name": "诉讼费"
					},
					{
						"name": "诉讼请求"
					},
					{
						"name": "判决结果"
					},

					
					{
						"name": "转款记录"
					},
					{
						"name": "转款日期"
					},
					{
						"name": "开票金额"
					},
					{
						"name": "开票日期"
					},
					{
						"name": "开票信息"
					},
					
					{
						"name": "付款方式"
					},
					{
						"name": "附件数量"
					},
					{
						"name": "附件路径"
					},
					{
						"name": "状态"
					},
					{
						"name": "其他费用"
					},
					{
						"name": "修改人"
					},
					// {
					//   "name": "浏览地址"
					// },
					// {
					//   "name": "存储地址"
					// },
					{
						"name": "修改时间"
					}
				]

				this.load_db_data();
			},
			loadClass: function(action, p1, p2, p3) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2, p3)
					).then(res => {
						res = JSON.parse(res);
						// console.log(res.data);
						resolve(res.data)
					});

				});
			},
			fun_show_file: function() {

				console.log('sheet_no' + this.sheet_no);

				if (typeof(this.sheet_no) == 'undefined' || this.sheet_no == '') {
					this.$message({
						message: '请选择要修改的数据!',
						type: 'warning'
					});
					return;
				}

				this.show_filedata = '';
				this.show_filedata = JSON.stringify({
					"title": '编号' + this.sheet_no + ' 原告' + this.one_name + ' 附件管理',
					"sheet_no": this.sheet_no,
					"flag": this.flag,
					"p1": 'bdwl',
					"p2": 'case',
					"p3": this.sheet_no
				});
				this.show_file = (Math.random() + '').substring(0, 8);

			},
			fun_show_detail: function(t) {
				console.log(t);
				this.file_url = '';
				this.file_src = '';
				this.file_url = t.f_url;
				this.file_src = t.f_src;
				this.fun_look_file();
			},
			select_method: function(type) {
				// console.log('操作=' + type);
				switch (type) {
					case 'new':
						this.data_clear();
						break;
					case 'showblank':
						this.new_blank();
						break;
					case 'add':
						// 不能在方法里传  this.变量
						this.fun_upd('_add');
						break;
					case 'upd':
						this.fun_upd('_upd');
						break;
					case 'del':
						this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							this.show_main_edit = false;
							this.show_main_sel = false;
							this.fun_upd('_del');
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消删除'
							});
						});
						break;
					case 'sel':
						// this.closeshow();
						this.load_db_data();
						break;
					case 'sub':

						if (this.is_step_pass == '1') {
							this.fun_show_pass();
						} else {
							this.fun_upd('_sub');
						}
						break;
					case 'bad':
						this.fun_upd('_bad');
						break;
					case 'exl_up':
						this.excelup();
						break;
					case 'exl_down':
						this.build_exceldata();
						break;
					case 'filesel':
						this.fun_sel_file();
						break;
					case 'fileup':
						this.fun_up_file();
						break;
					case 'filelook':
						this.fun_look_file();
						break;
					case 'filedel':
						this.fun_del_file();
						break;
					default:
						this.$message.error('错误:标识:' + type + ' 没有配置相应方法!');
						break;
				}
			},
			load_db_data: function() {
				// console.log('全条件查询====');
				for (let i = 0; i < this.parm_sel.length; i++) {
					switch (this.parm_sel[i].sel) {
						case '1':
							this.kw1 = this.parm_sel[i].val;
							break;
						case '2':
							this.kw2 = this.parm_sel[i].val;
							break;
						case '3':
							this.kw3 = this.parm_sel[i].val;
							break;
						case '4':
							this.kw4 = this.parm_sel[i].val;
							break;
						case '5':
							this.kw5 = this.parm_sel[i].val;
							break;
						case '6':
							this.kw6 = this.parm_sel[i].val;
							break;
						case '7':
							this.kw7 = this.parm_sel[i].val;
							break;
						case '8':
							this.kw8 = this.parm_sel[i].val;
							break;

					}
				}
				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				setTimeout(function() {
					that.load_url = api.http_method;
					that.load_json = Select_PageLength('data_' + that.sel_action, that.nowpage, that
						.page_length, that.kw1, that
						.kw2, that.kw3, that.kw4, that.kw5, that.kw6, that.kw7, that.kw8, r);
				}, 200);
			},
			refresh_data: async function(page, type, pagelength, backdata) {
				// 返回修改成功后的结果。

				let r = (Math.random() + '').substring(0, 8);

				if (typeof(page) === 'undefined' || Number(page) == 0) {
					page = 1;
				}

				if (typeof(pagelength) === 'undefined' || Number(pagelength) == 0) {
					pagelength = 20;
				}

				console.log('查询刷新=' + type + ' page=' + page + ' pagelength=' + pagelength);
				// console.log(backdata);
				// PAGE_LENGTH_CHANGE 改变分页长度,刷新加载

				this.page_length = pagelength;
				this.nowpage = page;

				// console.log(backdata);
				let back = null;
				if (typeof(backdata) != "undefined" && backdata != '') {
					back = JSON.parse(backdata);
					console.log(back);
					// console.log('new_id=' + back.new_id);
					this.row_id = back.new_id;
					// 同步关键参数便于后续修改
					this.sheet_flag = back.msg;
					this.sheet_no = back.keyword.sheet_no;
					this.sys_date = back.keyword.sys_date;
				}

				if (this.sheet_flag.indexOf('删除成功') == 0) {
					await this.data_clear();
					this.load_db_data();
				}

				// 检查 单号是 ID还是 单号，针对有的单据没有单号的情景
				if (Number(this.sheet_no) > 0 && Number(this.sheet_no) < 999999) {
					this.sheet_no = 'ID' + this.sheet_no;
				}

				console.log('sheet_no=' + this.sheet_no);
				if (typeof(this.sheet_no) != "undefined" && this.sheet_no != '') {
					this.element_loading = true;
					this.$post(
						api.http_method, Select_PageLength('data_' + this.sel_action, 1, 1, this.sheet_no, '', '',
							'',
							'',
							'', '',
							'', r)
					).then(res => {
						
						res = JSON.parse(JsonCheck(res));
						// console.log(res.data);

						if (Number.parseInt(res.data.status) == 1) {
							let bd = [];
							let t = res.data.data;
							for (let i = 0; i < t.length; i++) {
								let arr = [];
								for (let j in t[i]) {
									// console.log('key=' + j);       //输出key
									// console.log('val=' + t[i][j]); //输出key对应的value
									let o = {};
									o.key = j;
									o.val = t[i][j];
									arr.push(o);
								}
								bd.push(arr);
							}

							this.sel_row(bd[0], 'edit');

							this.load_db_data();

						} else {
							this.$message({
								message: '编辑数据更新失败! \r\n ' + res.data.msg,
								type: 'success'
							});
						}
						this.element_loading = false;
					});

				}

				this.load_db_data();
			},
			excelup: function() {
				var that = this;
				this.$nextTick(function() {
					that.$refs['excelup'].show_edit();
				});
			},
			sel_row: function(item, type) {
				console.log(item);
				// 判断 obj.hasOwnProperty("key")
				//2、遍历Json串获取其属性
				this.row_id = item.id;
				this.sheet_flag = item.flag;
				this.sys_date = item.sys_date;
				this.sheet_no = item.sheet_no;
				this.one_name = item.one_name;

				let p = [];
				for (let j in item) {
					// console.log(j);
					// console.log('key=' + j); //输出key
					// console.log('val=' + item[j]); //输出key对应的value
					let o = {};
					o.key = j;
					o.val = item[j];
					p.push(o);
				}
				// console.log(p);

				for (let i = 0; i < p.length; i++) {
					for (let j = 0; j < this.parm.length; j++) {
						if (this.parm[j].key == p[i].key) {
							// console.log(this.parm[j].type+'  =  '+item[i].val);
							if (this.parm[j].type == 'radio') {

								for (let k = 0; k < this.parm[j].name.length; k++) {
									// console.log(' id='+this.parm[j].name[k].id+' name='+this.parm[j].name[k].name + ' = ' + item[i].val);
									if (this.parm[j].name[k].name == p[i].val) {
										this.parm[j].val = this.parm[j].name[k].id;
										this.radio = this.parm[j].name[k].id;
										break;
									}
								}

							} else if (this.parm[j].type == 'select') {
								for (let m = 0; m < this.parm[j].list.length; m++) {
									if (this.parm[j].list[m].val == p[i].val) {
										this.parm[j].val = this.parm[j].list[m].id;

										break;
									}
								}
								this.parm[j].sel_name = p[i].val;
							} else if (this.parm[j].type == 'checkbox') {
								this.parm[j].checked_list = p[i].val.split(',');
								this.parm[j].val = p[i].val.split(',');
							} else if (this.parm[j].type == 'fixed') {

							} else {
								this.parm[j].val = p[i].val;
							}
						}
					}

				}

				// 切换背景色
				this.$refs.file_table.setCurrentRow(item, 'm_');
			},
			data_clear: function() {
				// console.log('清除 历史 参数。。。。');
				this.bak_data = ''; //防止重复操作记录

				this.row_id = '';
				this.sel_item = {}; //备份点击项目
				// 文件名称、路径、储存 选择确定
				this.sheet_flag = '';
				this.sheet_no = '';

				this.file_name = '';
				this.file_url = '';
				this.file_src = '';
				this.file_up = '';

				for (let j = 0; j < this.parm.length; j++) {
					if (typeof(this.parm[j].type) != 'undefined' && this.parm[j].type == 'select') {
						this.parm[j].val = '';
						this.parm[j].sel_name = '';
						this.parm[j].sel_val = {};
					} else if (typeof(this.parm[j].type) != 'undefined' && this.parm[j].type == 'fixed') {

					} else {
						this.parm[j].val = '';
					}

				}

				for (let j = 0; j < this.parm_sel.length; j++) {
					if (typeof(this.parm_sel[j].type) != 'undefined' && this.parm_sel[j].type == 'select') {
						this.parm_sel[j].val = '';
						this.parm_sel[j].sel_name = '';
						this.parm_sel[j].sel_val = {};
					} else if (typeof(this.parm_sel[j].type) != 'undefined' && this.parm_sel[j].type == 'fixed') {

					} else {
						this.parm_sel[j].val = '';
					}

				}

			},
			fun_upd: function(type) {
				// console.log('操作类型=' + type + ' row_id=' + this.row_id);
				if (type == '_upd') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要修改的数据!',
							type: 'warning'
						});
						return;
					}
				}

				if (type == '_add') {
					let stop = false;
					let temp_name = '';
					for (let i = 0; i < this.parm.length; i++) {
						// console.log(this.parm[i]);
						if (this.parm[i].p == '1' && this.parm[i].weight == '1' && this.parm[i].val == '') {
							stop = true;
							temp_name = this.parm[i].name;
							break;
						}
					}
					if (stop) {
						this.$message({
							message: temp_name + '不能为空!',
							type: 'warning'
						});
						return;
					}
				}

				let d = [];
				for (let i = 0; i < this.parm.length; i++) {
					// console.log(this.parm[i].val);
					if (this.parm[i].p == '1')
						d.push(this.parm[i].val);
				}


				let r = (Math.random() + '').substring(0, 8);
				this.upd_json = Method_CommonLong('data_' + this.upd_action + type, this.row_id, this.sys_date, d,
					r);

			},
			show_detaildata: function(that, item, type) {
				var x = 0,
					y = 0,
					temp_css = '';
				// console.log('明细数据显示坐标 ' + x + ' ' + y);
				// console.log(item);
				x = that.clientX + 10;
				y = that.clientY;
				temp_css = "display: block;position: absolute;top:" + y + "px;left:" + x +
					"px;background-color: #99CCFF;border: 1px solid black;padding-left: 20px;padding-right: 20px;border-radius: 5px;z-index: 99999;";
				if (type == "0" && item.detail_data.length > 0) {
					this.detail_data = item.detail_data;
					// console.log($('#pre_detail_data'));
					document.getElementById("pre_detail_data").style.cssText = temp_css;
				}
				if (type == "1" && item != '') {
					temp_css += "max-width: 400px;word-break: break-all;padding-top: 5px;padding-bottom: 5px;";

					let temp_innerHtml = '';
					temp_innerHtml = BackSpecial(item);
					if (temp_innerHtml.indexOf('^') > 0) {
						let arr = temp_innerHtml.split('^');
						let new_str = '';
						for (let i = 0; i < arr.length; i++) {
							new_str = new_str + arr[i] + "<br/>";
						}
						temp_innerHtml = new_str;
					} else {

						temp_innerHtml = temp_innerHtml.replace(/\r\n/g, "<br/>");
					}


					document.getElementById("pre_msg_data").innerHTML = temp_innerHtml;
					document.getElementById("pre_msg_data").style.cssText = temp_css;
				}
			},
			noshow_detaildata: function() {
				// console.log('不显示明细');
				document.getElementById("pre_detail_data").style.display = 'none';
				document.getElementById("pre_msg_data").style.display = 'none';
			},
			build_exceldata: function(type) {
				// 不做分页
				console.log('导出=' + type);
				if (type == 'close') {
					this.show_excel = false;
				} else {
					for (let i = 0; i < this.parm_sel.length; i++) {
						switch (this.parm_sel[i].sel) {
							case '1':
								this.kw1 = this.parm_sel[i].val;
								break;
							case '2':
								this.kw2 = this.parm_sel[i].val;
								break;
							case '3':
								this.kw3 = this.parm_sel[i].val;
								break;
							case '4':
								this.kw4 = this.parm_sel[i].val;
								break;
							case '5':
								this.kw5 = this.parm_sel[i].val;
								break;
							case '6':
								this.kw6 = this.parm_sel[i].val;
								break;
						}
					}

					this.postjson1 = Object.assign({}, this.postjson1, {
						type: 'down1',
						url: api.http_method,
						post: Select_PageLength('data_' + this.sel_action, this.nowpage, this.page_length, this
							.kw1, this.kw2,
							this.kw3, this.kw4, this.kw5, this.kw6)
					});

					this.show_excel = true;
				}
			},
			//附件操作 start //////////////////////////////////////
			// 点击上传附件
			fun_sel_file: function() {
				// console.log('点击选择附件=' + this.row_id);
				if (this.row_id == null || Number(this.row_id) == 0) {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,请选择需要上传附件<div class="mtop mdown" > 明细项目=' + this.file_name +
							'</div>请检查!'
					});
					return;
				}
				// console.log(this.file_url);
				if (this.file_url != '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				this.file_name = '';
				this.file_data = '';
				this.file_up = '';
				let fileobj = document.getElementById('hetong_file');
				fileobj.click();
			},
			fun_look_file: function() {
				console.log('点击预览附件');
				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 合同名称=' + this.f_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					this.pdfview = document.getElementById('loodlink');
					this.pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					this.pdfview.click();
				} else {
					let temp_url = BackSpecial(BackSpecial(this.file_url));
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					let temp_src = BackSpecial(BackSpecial(this.file_src));
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});
					let temp_type = temp_filename.substring(temp_filename.lastIndexOf('.') + 1);
					// console.log(encodeURI(temp_url));
					// console.log(encodeURI(temp_filename));

					// console.log(temp_url);
					// console.log(temp_filename);
					// console.log(temp_type);
					// console.log('=================');


					//a标签中参数中带有中文，导致不能正常下载
					// 2021-07-15 360浏览器可以,不能在谷歌浏览器里下载
					// let down_file = document.getElementById("editdownlink");
					// down_file.download = encodeURI(temp_filename); // 下载名称
					// down_file.href = encodeURI(temp_url); // 绑定a标签
					// down_file.click(); // 模拟点击实现下载  要点很多下才响应

					// 360浏览器可以,谷歌不可以
					// window.location.href = encodeURI(temp_url);

					// var a = document.createElement('a');
					// a.download = temp_filename;
					// a.href = encodeURI(temp_url);
					// $("body").append(a);
					// a.click();
					// $(a).remove();



					// let postdata = '';
					// postdata =
					//   '{"file_src":"' + temp_src + '","file_name":"' + temp_filename + '"}';
					// postdata =
					//   '{"method":"File_data","data":"' + base_encode(postdata) + '"}';
					// let that = this;
					// this.$post(
					//   api.http_method,
					//   postdata
					// ).then(res => {
					//   res = JSON.parse(res);
					//   console.log(res);
					//   if (res.data.status == '1') {
					//     console.log('字符长度:' + res.data.data.length);
					//     // 使用download.js文件下载
					//     // downloadfile(blob,temp_filename,temp_type);
					//     // console.log(res);
					//   }
					// });

					let postdata = '';
					postdata =
						'{"file_src":"' + temp_src + '","file_name":"' + temp_filename + '"}';

					postdata = base_encode(postdata);
					let that = this;
					this.$get(
						api.http_downfile,
						postdata
					).then(res => {
						that.saveFile(res, temp_filename);
					});

				}
			}, //保存文件
			saveFile: function(data, fileName) {
				var export_blob = new Blob([data]);
				var save_link = document.createElement('a');
				document.body.appendChild(save_link);
				save_link.style.display = 'none';
				var urlObject = window.URL.createObjectURL(export_blob);
				save_link.href = urlObject;
				save_link.download = fileName;
				save_link.click();
				document.body.removeChild(save_link);
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('hetong_file');
				// console.log('点击选择结果');
				// console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 200000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];
					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					// console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf|doc|docx|zip|rar)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;
					this.file_show = true;
					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小=' + size + '超过最大限制50M',
							type: 'warning'
						});
						return
					}
					// console.log(tmpFile);   //连标签原样输出了
					// console.log(tmpFile.value);   //图片路径

					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					// console.log(size / 1024 + 'kB');
				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			fun_del_file: function() {
				console.log('点击删除附件');
				if (this.sheet_flag == '完成' || this.sheet_flag == '已提交') {
					this.$message({
						message: '单据已经完成,不能删除附件!',
						type: 'warning'
					});
					return;
				}

				if (this.file_url == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '请确定选择单据已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				// 第一步 删除存储路径
				this.fun_del_file_two();
				// 第二步 删除真实文件
				this.fun_del_file_three(this.file_src);
			},
			fun_del_file_two: function() {
				var postdata = "";
				postdata =
					'{"action":"' + 'data_del_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","sheet_no":"' +
					this.sheet_no +
					'","rowid":"' +
					this.row_id +
					'"}';

				// console.log(postdata);
				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';

				// postdata = base_encode(postdata);

				this.$post(
					api.http_method, postdata
				).then(res => {
					res = JSON.parse(res);

					this.$message({
						message: res.data.msg,
						type: 'success'
					});

				});

			},
			fun_del_file_three: function() {
				// console.log('删除路径 \r\n' + this.file_src);
				var postdata = '';
				postdata =
					'{"method":"File_del","data":"' + base_encode(this.file_src) + '"}';
				this.$post(
					api.http_method, postdata
				).then(res => {

					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'success'
						});

						console.log(res.data);
						this.file_name = '';
						this.file_url = '';
						this.file_src = '';
						this.file_up = '';

					} else {
						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'warning'
						});
					}
				});
			},
			fun_up_file: async function() {
				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				// console.log('base64文件大小=' + this.file_data.length)
				if (this.file_data.length > 0) {
					// console.log('大文件上传');
					// this.element_loading = true;
					let random_name = GetRandom();
					this.file_name = random_name + this.file_name;

					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_min: function() {


				// console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";
				postdata =
					'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					this.file_data +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';
				postdata =
					'{"method":"File_load","data":"' + base_encode(postdata) + '"}';


				let that = this;
				var loaded = 0,
					total = 0;
				this.$postfile(
					api.http_method,
					postdata,
					res => {
						loaded = res.loaded;
						total = res.total;
						this.$nextTick(() => {
							that.file_up = ((loaded / total) * 100).toFixed(2) + " %";
						});
					}
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.refresh_data();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});


			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				// console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// console.log('上传长度=' + temp_data.size);
					// console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {
							// let maxTime = 3;
							// let min = 0
							// let resTwo = '';
							// while (min < maxTime) {
							//   resTwo = await this.fun_up_file_block(temp_data);
							//   if (resTwo.status != 1) {
							//     this.$message({
							//       message: '上传出错请稍后重新上传',
							//       type: 'success'
							//     });
							//   }
							//   min++;
							// }

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";
				// postdata = {
				//   "action": 'data_save_' + that.file_action,
				//   'user_no': that.user_no,
				//   "p1": that.p1,
				//   "p2": that.p2,
				//   "p3": that.p3,
				//   "row_id": that.row_id,
				//   "sheet_no": that.key_word
				// };
				let temp_filedata = await this.fun_blod_toString(temp_data);

				postdata =
					'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					temp_filedata +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';
				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				console.log('p3=' + this.p3);
				this.element_loading = true;
				var postdata = "";
				postdata =
					'{"action":"' + 'data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(DeleteSpecialWord(this.file_name)) +
					// '","upfile_type":"' +
					// this.file_type +
					'","upfile_path":"' +
					this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
					'","upfile_data":"' +
					'' +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'"}';

				// console.log(postdata);
				postdata =
					'{"method":"File_SavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;
				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.refresh_data();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});

			},

		}
	};
</script>


<style scoped>
	.pretop {
		margin-top: 5px;
	}

	.content_edit_item label {
		min-width: 100px;
	}

	/* 设置 倒数 第二、第三列 隐藏 */
	.path520_none>td:nth-last-child(3),
	.path520_none>td:nth-last-child(2) {
		display: none;
	}

	/* 设置 倒数 第二、第三列 隐藏 */
	.last-two-none>th:nth-last-child(3),
	.last-two-none>th:nth-last-child(2),
	.last-two-none>td:nth-last-child(3),
	.last-two-none>td:nth-last-child(2) {
		display: none;
	}

	.last-two-none>th:nth-last-child(2),
	.last-two-none>td:nth-last-child(2) {
		display: none;
	}

	.edit_color {
		background-color: honeydew;
	}

	.checkbox_group {
		display: inline-block;
		vertical-align: middle;
	}

	.tab-row {
		display: block;
	}
</style>